import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client'; 

import { ConfigProvider, Drawer, message, theme } from 'antd';

import { DARK_BG_CONTAINER, LOCAL_MERCHANT_CODE } from '../../../helpers/Globals';
import MarketingAudienceCreateContent from './MarketingAudienceCreateContent';
import DiMarketingAudienceTour from '../../tours/DiMarketingAudienceTour';
import { apiGetAudience } from '../../../helpers/Api';
import confirmModal from '../../DiConfirmModal';

const createAudience = ({context, audienceId, onSave}) => {

   // ------------- Crea un div temporaneo nel DOM per far comparire il drawer -------------
   const drawerContainer = document.createElement('div');
   document.body.appendChild(drawerContainer);
   // ------------- Crea un div temporaneo nel DOM per far comparire il drawer -------------

   // ------------- Componente Drawer -------------
   const DrawerComponent = () => {
      

      const [showCloseWarning, setShowCloseWarning] = useState(false);
      const [audienceData, setAudienceData] = useState(null);
      const [loading, setLoading] = useState(false);
      const [open, setOpen] = useState(false);

      const { darkMode, errorNotification, publicCode } = context;

      const handleClose = async () => {
    
         if (showCloseWarning) {
            const result = await confirmModal(
               "Se hai effettuato delle modifiche, chiudendo le perderai... Consigliamo di salvare il pubblico. Sicuro di voler chiudere?",
               context
            ); //attendo la risposta dal componente di conferma modale

            if (result) {
               setOpen(false); 
            } else {
               return;
            }
         } else {
            setOpen(false);
         }

      };

      /////////////////////////////////////////////////////////////////////////////////////////// 
      //////////////// se c'è l'id prima di aprire il drawer recupero i dati dell'audience //////
      /////////////////////////////////////////////////////////////////////////////////////////// 

      useEffect(() => {
         if (!publicCode) {
            errorNotification("Public Code Assente")
            return
         };

         const fetchAudience = async () => {
            try {
               if (!audienceId) {
                  setOpen(true); // Se audienceId è null/undefined, apri il modal per crearne uno nuovo
                  return;
               }

               setLoading(true);
               message.loading("Caricamento...");

               const res = await apiGetAudience(publicCode, audienceId);
               if (res && res.success === true) {
                  setAudienceData(res.data);
                  setOpen(true);
               } else {
                  console.warn("Nessun dato ricevuto per l'audience:", audienceId);
               }
            } catch (error) {
               console.error("Errore nel recupero dell'audience:", error);
            } finally {
               message.destroy();
               setLoading(false);
            }
         };

         fetchAudience();
      }, [audienceId]);

      /////////////////////////////////////////////////////////////////////////////////////////// 
      //////////////// se c'è l'id prima di aprire il drawer recupero i dati dell'audience //////
      /////////////////////////////////////////////////////////////////////////////////////////// 
      
      return (
            <ConfigProvider
               theme={
               {
                  algorithm: darkMode ? theme.darkAlgorithm : theme.compactAlgorithm,
                  token:{
                     colorPrimary: "#008833",
                     colorBgContainer: darkMode ? DARK_BG_CONTAINER : "#fff"
                  }
               }
               }
            >
               <Drawer
                  title={!audienceId ? "Crea il tuo Pubblico" : `Stai modificando: ${audienceData?.title}`}
                  extra={<DiMarketingAudienceTour context={context}/>}
                  className='di-create-audience-drawer'
                  onClose={handleClose}
                  placement="bottom"
                  destroyOnClose
                  height="100%"
                  open={open}
               >
                  <MarketingAudienceCreateContent
                     setShowCloseWarning={setShowCloseWarning}
                     audienceData={audienceData}
                     contextValue={context}
                     closeModal={setOpen}
                     onSave={onSave}
                  />
               </Drawer>
            </ConfigProvider>
      );
   };
   // ------------- Componente Drawer -------------

   // ------------- rendering effettivo del drawer -------------
   const root = ReactDOM.createRoot(drawerContainer);
   root.render(<DrawerComponent />);
   // ------------- rendering effettivo del drawer -------------

};

export default createAudience;
